// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"index-module_pageContainer_1_7S9"};